(() => {
  const root = document.querySelector('.rs-contact-page');
  if (!root) return;
  root.querySelectorAll('[data-rs-contact-question] .faq-extended__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-rs-contact-question]');
      const group = item.closest('.faq-extended__collapses');
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      group.querySelectorAll('.faq-extended__item--open').forEach(open => {
        open.classList.remove('faq-extended__item--open');
        open.querySelector('.faq-extended__trigger').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('faq-extended__item--open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  root.querySelectorAll('[data-rs-track]').forEach(button => {
    button.addEventListener('click', async () => {
      const section = button.closest('.order-tracking');
      const input = section.querySelector('[data-rs-tracking-input]');
      const number = input.value.trim();
      if (!number) { input.setCustomValidity(button.dataset.emptyMessage); input.reportValidity(); input.focus(); return; }
      input.setCustomValidity('');
      button.disabled = true;
      try {
        if (!window.YQV5) await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://www.17track.net/externalcall.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        });
        const container = section.querySelector('[data-rs-tracking-results]');
        window.YQV5.trackSingle({ YQ_ContainerId: container.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: number });
      } catch {
        input.setCustomValidity(button.dataset.errorMessage);
        input.reportValidity();
      } finally { button.disabled = false; }
    });
  });
  root.querySelectorAll('[data-rs-tracking-input]').forEach(input => {
    input.addEventListener('input', () => input.setCustomValidity(''));
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); input.closest('.order-tracking').querySelector('[data-rs-track]').click(); } });
  });
})();
